import { ProductImage } from '../../generated/graphql'
import { productGallery } from './gallery'

export const defaultVariant = <
  InputVariant extends {
    product?: { sku: number } | null
    title: string
    images: ProductImage[]
  },
  Variant extends { title: string; images: ProductImage[] }
>(product: {
  sku: number
  defaultVariant?: Variant | null
  variants: InputVariant[]
}): (Variant | InputVariant) & {
  gallery: ReturnType<typeof productGallery>
} => {
  if (product.defaultVariant) {
    return {
      ...product.defaultVariant,
      gallery: productGallery(product.defaultVariant),
    }
  }

  const masterSKU = product.sku
  const masterProductVariant = product.variants.find(
    (variant) => variant.product?.sku === masterSKU,
  )

  const defaultVariant = masterProductVariant || product.variants[0]

  return {
    ...defaultVariant,
    gallery: productGallery(defaultVariant),
  }
}
